/* @flow */
import formSerialize from 'form-serialize';
import get from 'lodash/get';
import getFormularioPorId from '../utils/get-formulario-por-id';
import swal from '../utils/swal';
import { exibirToastError } from '../utils/alertas';
import api from '../utils/api';
import { type Usuario } from '../usuario/types';

const formulario = (usuario: Usuario) => `
<form id="editar-usuario" class="m-form m-form--fit m-form--label-align-right">
    <div class="m-portlet__body">
        <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-3 col-sm-12" for="nome-usuarios">
                Nome:
            </label>
            <div class="col-lg-6 col-md-9 col-sm-12">
                <input
                    type="text"
                    name="nome"
                    value="${usuario.nome}"
                    id="nome-usuarios"
                    class="form-control m-input"
                    maxlength="35"
                    required
                />
            </div>
        </div>
        <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-3 col-sm-12" for="nascimento-usuarios">
                Nascimento:
            </label>
            <div class="col-lg-6 col-md-9 col-sm-12">
                <input
                    type="date"
                    name="nascimento"
                    value="${usuario.nascimento ? usuario.nascimento : ''}"
                    id="nascimento-usuarios"
                    class="form-control m-input"
                    required
                />
            </div>
        </div>
        <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-3 col-sm-12" for="cpf-usuarios">
                CPF:
            </label>
            <div class="col-lg-6 col-md-9 col-sm-12">
                <input
                    type="text"
                    name="cpf"
                    value="${usuario.cpf ? usuario.cpf : ''}"
                    id="cpf-usuarios"
                    class="form-control m-input"
                    maxlength="35"
                    required
                />
            </div>
        </div>
        <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-3 col-sm-12" for="email-usuarios">
                E-mail:
            </label>
            <div class="col-lg-6 col-md-9 col-sm-12">
                <input
                    type="text"
                    name="email"
                    value="${usuario.email ? usuario.email : ''}"
                    id="email-usuarios"
                    class="form-control m-input"
                    maxlength="35"
                    required
                />
            </div>
        </div>
        <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-3 col-sm-12" for="senha-usuarios">
                Senha:
            </label>
            <div class="col-lg-6 col-md-9 col-sm-12">
                <input
                    type="password"
                    name="senha"
                    value="${usuario.senha ? usuario.senha : ''}"
                    id="senha-usuarios"
                    class="form-control m-input"
                    maxlength="14"
                    required
                />
            </div>
        </div>
        <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-4 col-sm-12" for="ativo-usuarios-sim">
                Ativo?
                <span class="m--font-danger">*</span>
            </label>
            <div class="col-2">
                <div class="m-radio-inline">
                    <label class="m-radio m-radio--bold m-radio--state-success">
                        <input
                            type="radio"
                            name="ativo"
                            value="1"
                            id="ativo-usuarios-sim"
                            ${usuario.ativo === 1 ? 'checked' : ''}
                            >
                                Sim
                            <span></span>
                    </label>
                    <label class="m-radio m-radio--bold m-radio--state-danger">
                        <input
                            type="radio"
                            name="ativo"
                            value="0"
                            id="ativo-usuarios-nao"
                            ${usuario.ativo === 0 ? 'checked' : ''}
                        >
                            Não
                        <span></span>
                    </label>
                </div>
            </div>
        </div>
    </div>
</form>
`;

const getDadosForm = (form: HTMLElement): Object => (
    formSerialize(form, { hash: true, empty: true })
);

const formularioUsuario = async (usuarioId: number) => {
    try {
        const { data: usuario } = await api.getUsuarioPorId(usuarioId);

        swal.fire({
            title: 'Editar usuário',
            width: 1300,
            scrollbarPadding: false,
            confirmButtonColor: '#36a3f7',
            html: formulario(usuario),
            focusConfirm: false,
            preConfirm: async () => {
                const data = getDadosForm(getFormularioPorId('editar-usuario'));

                const exchangeObject = {
                    ...usuario,
                    ...data,
                    origem: 'admin',
                };

                delete exchangeObject.contatos;
                delete exchangeObject.contatosUrl;

                try {
                    await api.editarUsuarioPorId(usuario.id, exchangeObject);
                } catch (error) {
                    swal.showValidationMessage(get(
                        error,
                        'response.data.message',
                        'Algo deu errado ao editar',
                    ));
                }
            },
        });
    } catch (error) {
        exibirToastError(get(
            error,
            'response.data.message',
            'Algo deu errado',
        ));
    }
};

export default formularioUsuario;
